/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BagCountQueryVariables = Exact<{ [key: string]: never }>;

export type BagCountQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'LineItem';
      readonly id: string;
      readonly quantity: number;
    }>;
  } | null;
};

export const BagCountDocument = gql`
  query BagCount {
    cart {
      id
      __typename
      lineItems {
        id
        quantity
        __typename
      }
    }
  }
`;

export function useBagCountQuery(
  options?: Omit<Urql.UseQueryArgs<BagCountQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagCountQuery, BagCountQueryVariables>({
    query: BagCountDocument,
    ...options,
  });
}
